// reducer.js
import * as types from "../../constants/constants";

const initialState = {
  isLoading: false,
  isError: false,
  Authtoken: null,
  LessonId: "",
  topicId: "",
};

const otpVerificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.VERIFY_OTP:
      return {
        ...state,
        isLoading: true,
        isError: false,
        Authtoken: null,
      };
    case types.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        profile: action?.payload?.data,
        Authtoken: action?.payload?.token,
        isLoading: false,
        isError: false,
      };
    case types.VERIFY_OTP_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        Authtoken: null,
      };

    case types.VERIFY_EMAIL:
      return {
        ...state,
        isLoading: true,
        isError: false,
        Authtoken: null,
      };
    case types.VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        profile: action?.payload?.data,
        // Authtoken: action?.payload?.token,
        isLoading: false,
        isError: false,
      };
    case types.VERIFY_EMAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        Authtoken: null,
      };
    case types.LESSON_ID_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case types.LESSON_ID_SUCCESS:
      return {
        ...state,
        LessonId: action?.payload,
        isLoading: false,
        isError: false,
      };
    case types.LESSON_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case types.TOPIC_ID_SUCCESS:
      return {
        ...state,
        topicId: action?.payload,
        isLoading: false,
        isError: false,
      };
    default:
      return state;
  }
};

export default otpVerificationReducer;
